import { Button, Dialog, DialogButtons } from '@st/theme'

export function PaymentRequiredNotice({
  onClose,
  onGoToDashboard
}: {
  onClose: () => void
  onGoToDashboard: () => void
}) {
  return (
    <Dialog
      title="Pay invoice"
      subtitle="Please pay your invoice and click “I’ve paid” before signing. You can find a link to the invoice on the dashboard."
      buttons={
        <DialogButtons>
          <Button variant="subtle" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={onGoToDashboard}>
            Go to dashboard
          </Button>
        </DialogButtons>
      }
    />
  )
}
